import React, { useState, useCallback } from "react";
import "./AddGroupModal.scss";
import { toast } from "react-toastify";
import CustomModal from "../../Common/CustomModal";
import FormField from "../../FormField/FormField";
import { saveGroup } from "../../../api";
import Select from "react-select";
import { getReactSelectThemeProps } from "../../../helpers/reactSelectThemeStyles";

const reactSelectThemeProps = getReactSelectThemeProps();

const AddUserModal = ({ isOpen, onClose, fetchGroups, organization, organizationsData }) => {
  const [formData, setFormData] = useState({
    name: "",
    color: "#000000"
  });
  const [selectedOrganization, setSelectedOrganization] = useState({ value: organization.id, label: organization.name });

  const handleChange = useCallback(
    (key, value) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    },
    [formData]
  );

  const handleSubmit = useCallback(async () => {
    try {
      await saveGroup({...formData, organizationId: selectedOrganization.value});
      await fetchGroups();
      toast.success("Role saved successfully");
    } catch (err) {
      console.error("Error while saving role", err);
      toast.error("Error while saving role");
    } finally {
      onClose();
    }
  }, [formData, onClose, fetchGroups]);

  const handleOrganizationSelectChange = useCallback((org) => {
    setSelectedOrganization(org);
    // Note: selectedOrganization will still show the old value here due to async state updates
  }, []);

  return (
    <CustomModal title={"Add New Group"} isVisible={isOpen} onClose={onClose}>
      <div className="add-role-modal-body">
        <div className="input-wrapper">
          <label htmlFor="name" className="input-label">
            Nome del gruppo
          </label>
          <input
            id="name"
            type="text"
            name="name"
            value={formData.name}
            onChange={(e) => handleChange("name", e.target.value)}
          />
        </div>
        { organization?.id === null ?
            ( <div className="input-wrapper">
              <label htmlFor="organization" className="input-label">
                Organization:
              </label>
              <Select
                name="organization"
                options={organizationsData}
                value={selectedOrganization}
                placeholder="Seleziona un'organizzazione"
                onChange={handleOrganizationSelectChange}
                {...reactSelectThemeProps}
              />
            </div> )
          : null
          }
        <FormField
          fieldStructure={{
            label: "Colore",
            type: "color",
            editable: true,
          }}
          value={formData.color}
          onChange={(newValue) => handleChange("color", newValue)}
          disabled={false}
        />
      </div>
      <footer className="modal-footer">
        <button
          type="submit"
          className="modal-footer-button"
          onClick={handleSubmit}
        >
          Add
        </button>
      </footer>
    </CustomModal>
  );
};

export default AddUserModal;
